import BoardRoutes from './board';
// import StaffRoutes from './staff';
import MilestonesRoutes from './milestones';
import TagsRoutes from './tags';
import InvoiceRoutes from './invoices';
import ClientContractsRoutes from './client-contracts';
import ClientEmployeesRoutes from './client-partners';
import AdminRoutes from './admin';
import WorkforceRoutes from './workforce';
import OverviewRoutes from './overview';
import JobApplicationRoutes from './job-application';
import Applicant from './applicants';
import RecruitmentRoutes from './recruitment';
import FormsRoutes from './forms';
import OrganizationRoutes from './organization';
import InitialOnboardingRoutes from './initial-onboarding';
import SupervisorManagerRoutes from './supervisor-manager';
import HRPortalRoutes from './hr-portal';
import EmploymentRoutes from './employment';
import AcknowledgementRoutes from './acknowledgements';
import MemorandumRoutes from './memorandums';
import store from 'source/store';

const routes = [
    ...AdminRoutes,
    ...BoardRoutes,
    // christiandieziv@bposeats.com commenting this out as this gives complications to routing
    // for it has the same route name with some of the StaffSidebar routes
    // ...StaffRoutes,
    ...MilestonesRoutes,
    ...TagsRoutes,
    ...InvoiceRoutes,
    ...ClientContractsRoutes,
    ...ClientEmployeesRoutes,
    ...WorkforceRoutes,
    ...OverviewRoutes,
    ...JobApplicationRoutes,
    ...Applicant,
    ...RecruitmentRoutes,
    ...FormsRoutes,
    ...OrganizationRoutes,
    ...InitialOnboardingRoutes,
    ...SupervisorManagerRoutes,
    ...EmploymentRoutes,
    ...AcknowledgementRoutes,
    ...HRPortalRoutes,
    ...MemorandumRoutes
];

export default [
  {
    path: '/company/:company_id/workforce/:workforce_id/',
    name: 'internal',
    component: () => import('source/pages/root/InternalPageRoot.vue'),
    meta: {
      title: 'Administrator - HQZen',
      canDisplayGlobalModals: true,
      isAdministratorRoute: true,
    },
    beforeEnter: (to, from, next) => {
      const user = store.state.auth.user;
      if (!from.name && user &&
          user.user_profile && user.user_profile.signup_source_display==='Business Signup' &&
          !user.user_profile.is_fully_verified &&
          to.name !== 'board-main') {
        next({ name: 'board-main', params: {
          company_id: user.user_profile.company.pk,
          workforce_id: user.user_profile.workforce_ids[0],
          board_id: -1
        }, });
      } else {
        next();
    }
  },
    children: [...routes],
  },
];

